<!-- product-info-screen.component.html -->
<div class="product-list-container">

  <!-- Show empty state if nothing active -->
  <ng-container *ngIf="activeProducts?.length > 0; else emptyState">

    <div class="product-list">
      <h2 style="    justify-self: normal; margin: 1rem 2rem  0 2rem ; font-weight: 700;"> Produkte</h2>
      <mat-card *ngFor="let product of activeProducts" class="product-card"
        (click)="onProductCardClick(product); toggle(product.id)">
        <div class="product-summary-card">
          <div class="summary-content">
            <div class="image-wrapper">
              <div class="image-preview">
                <app-secure-image [src]="this.productPictureUrl" [fileId]="product.fileId"></app-secure-image>
              </div>
            </div>
            <div>
              <div class="summary-title">
                {{ product?.name || 'Produkt' }}
              </div>
              <div class="summary-meta">
                <span>{{ latestVersionName(product) }}</span>
                <!--                         <span>Varianten: {{ product?.productVariants?.length || 0 }}</span> -->
              </div>
            </div>
          </div>
          <div style="    display: flex; align-items: center;">
            <p class="Pkg" *ngIf="product.listingPkgName"> {{ product.listingPkgName }} </p>
            <button mat-icon-button class="expand-icon"
              (click)="$event.stopPropagation(); onProductCardClick(product); toggle(product.id)"
              [attr.aria-expanded]="isExpanded(product.id)" [class]="{ rotated: isExpanded(product.id) }">
              <mat-icon>expand_more</mat-icon>
            </button>
            <button mat-icon-button (click)="$event.stopPropagation(); onProductCardClick(product)"
              [matMenuTriggerFor]="moreMenu" aria-label="More actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu">
              <button mat-menu-item (click)="onProductEdit(product.id)">
                <span>Bearbeiten</span>
              </button>
              @if (product.listingPkgName != null) {
              <button mat-menu-item (click)="changeProductLicense(product.id)">
                <span>Tarif wechseln</span>
              </button>
              } @else {
              <button mat-menu-item (click)="changeProductLicense(product.id)">
                <span>Produkt aktivieren</span>
              </button>
              }
              <button mat-menu-item (click)="deleteProduct(product.id)">
                <span>Produkt löschen</span>
              </button>
            </mat-menu>
          </div>

        </div>

        <!-- Noch mal prüfen -->
        <mat-card-content>
          <div *ngIf="isExpanded(product.id)" hideToggle class="product-expansion">
            <div class="expanded-content">
              <!-- Product level info -->
              <app-info-box [product]="product"></app-info-box>

              <div class="version-divider">
                <h2>Varianten</h2>
                <div class="dividerline"></div>
              </div>
              <div style="width: 100%;
            display: flex;
            justify-content: flex-end;">
                <span [matTooltip]="hasReachedVariantLimit(product) 
                  ? `Es können maximal ${MAX_VARIANTS_PER_PRODUCT} Varianten pro Produkt angelegt werden.` 
                  : ''" matTooltipPosition="above">
                  <button *ngIf="isUserOrganisationAdminOrPlattformAdmin()" matButton="elevated" color="primary"
                    (click)="$event.stopPropagation(); onVariantAdd(product.id)" aria-label="Produkt anlegen"
                    [disabled]="hasReachedVariantLimit(product)">
                    <mat-icon> add</mat-icon>
                    Neue Variante anlegen
                  </button>
                </span>
              </div>
              <!-- Variants -->
              <div>
                <app-info-box (click)="$event.stopPropagation(); "
                  *ngFor="let variant of (product?.productVariants || [])" [variant]="variant" [product]="product"
                  style="margin: 10px;"></app-info-box>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="actions-row">
        <button *ngIf="isUserOrganisationAdminOrPlattformAdmin()" matButton="elevated" color="primary"
          (click)="onCreateProduct()" aria-label="Produkt anlegen">
          <mat-icon> add</mat-icon>
          Neues Produkt anlegen
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="empty-state" style="width: 100%;">
      <div class="product-list">
        <h2 style="    justify-self: normal; margin: 1rem 2rem  0 2rem ; font-weight: 700;"> Produkte</h2>
        <h3 *ngIf="!isLoading">Es wurden noch keine Produkte angelegt</h3>
        <div class="actions-row">
          <button *ngIf="isUserOrganisationAdminOrPlattformAdmin()" matButton="elevated" color="accent"
            (click)="onCreateProduct()" aria-label="Produkt anlegen">
            <mat-icon> add</mat-icon>
            Neues Produkt anlegen
          </button>
        </div>
      </div>
    </div>
  </ng-template>

</div>

@if (isLoading) {
<div class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>
}